// extracted by mini-css-extract-plugin
export default {"list":"style_list__jGAWO","newsItem":"style_newsItem__24Qut","content":"style_content__uTCDe","title":"style_title__nFm3b","date":"style_date__JMM+J"};